import { z } from 'zod';

import { zipValidation, getLocale } from '@libs/core';
import {
    cityRequiredMsg,
    streetAddressRequiredMsg,
    zipRequiredMessages,
    zipInvalidMessages,
    stateRequiredMessages,
} from './validationErrors';

const citySchema = z.string().trim().min(1, cityRequiredMsg);
const streetAddressSchema = z.string().trim().min(1, streetAddressRequiredMsg);
const zipCodeSchema = z
    .string()
    .trim()
    .min(1, zipRequiredMessages[getLocale()])
    .refine(val => zipValidation(val), {
        message: zipInvalidMessages[getLocale()],
    });
const stateSchema = z
    .string()
    .trim()
    .min(1, stateRequiredMessages[getLocale()]);

export const addressFormSchema = z.object({
    streetAddress: streetAddressSchema,
    apt: z.optional(z.string().trim()),
    zipCode: zipCodeSchema,
    state: stateSchema,
    city: citySchema,
});

export type AddressFormType = z.infer<typeof addressFormSchema>;
